import { Component, Input, ViewChild } from '@angular/core';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from '../../services/popover.service';
import { CommonModule } from '@angular/common';

let id = Date.now();

@Component({
  standalone: true,
  imports:[CommonModule,MdbPopoverModule],
  selector: 'app-text-popover',
  templateUrl: './text-popover.component.html',
  styleUrls: ['./text-popover.component.scss']
})
export class TextPopoverComponent {
  @ViewChild('popover') popover: MdbPopoverDirective = null;
  @Input() public title: string = 'Help'
  @Input() public placement: string = 'right'
  @Input() public event: string = 'click'
  @Input() public text: string = ''
  @Input() public size: string = ''
  @Input() public type: string = 'content' // 'content', 'learn-more'
  @Input() public innerHTML: string = null
  @Input() public buttonHTML:string = null;

  private _id = id++;
  get id() {
    return `Popover-${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
  ) { }

  popoverClick(){
  }

  onPopoverShown(event = null): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }
}
